import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const RegistroProntuario = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="REGISTRO EM PRONTUÁRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Profissional" nome="profissional" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="50vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Dispõe de registro de prontuário" nome="registroProntuario" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim, Físico", "Sim, Eletrônico", "Sim, Físico e Eletrônico", "Não"]} />
                        <Select label="Anamnese" nome="anamnese" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Objetivo e Plano de Tratamento" nome="planoTratamento" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Evolução diária de tratamento" nome="evolucao" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Assinatura e Carimbo" nome="assinatura" modulo={modulo} index={n}
                            widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não Se Aplica"]} />
                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Conformidade com a Resolução COFFITO 414/2012"
                            nome="conformidade414" modulo={modulo} index={n}
                            widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default RegistroProntuario